import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Areas from "@/pages/Areas";
import AreaDetail from "@/pages/AreaDetail";
import GuideCost from "@/pages/GuideCost";
import ArticleGuide from "@/pages/ArticleGuide";
import About from "@/pages/About";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function ProtectedRoute({ children }) {
  const { authed, checking } = useAuth();
  if (checking) return <div className="flex min-h-screen items-center justify-center text-slate-400">Loading…</div>;
  return authed ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/areas" element={<Areas />} />
              <Route path="/areas/:slug" element={<AreaDetail />} />
              <Route path="/guides/house-cleaning-cost-hamilton" element={<GuideCost />} />
              <Route path="/guides/:slug" element={<ArticleGuide />} />
              <Route path="/about" element={<About />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
